import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import LoginBase from "components/LoginBase/LoginBase";

import Button from "components/CustomButtons/CustomButton";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import { getResource } from "../Services/ResourcesService";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles(styles);

export default function LoginPage() {
  const routeParams = useParams();
  const dispatch = useDispatch();
  const { category, fileName } = routeParams;

  const classes = useStyles();

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      getDataDocument();
    } else {
      window.location.replace("/auth/login-page");
    }
  }, [dispatch]);

  const getDataDocument = async (actionType) => {
    const resultSubmit = await dispatch(
      getResource({ filename: fileName, category: category })
    );
    if (
      !resultSubmit.payload.result
    ) {
      window.location.href = "/auth/login";
    } else {
      const byteCharacters = atob(resultSubmit.payload.data.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: resultSubmit.payload.data.mime,
      });
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName == "UnderwritingGuidelines.pdf" ? "Underwriting-Guidelines-Sanborns.2022.pdf" : resultSubmit.payload.data.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }
  };

  return (
    <LoginBase>
      <div style={{ marginTop: "10px" }} className={classes.center}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Button
              onClick={() => window.close()}
              style={{ backgroundColor: "#008670" }}
              block
            >
              Back to Home
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    </LoginBase>
  );
}
